import { Route, Routes } from "react-router-dom";
import { CatalogGradeProvider } from "./context/CatalogGradeContext";
import { CatalogGradePage } from "./pages/CatalogGradePage";
import { UploadGradesPage } from "./pages/UploadGradesPage";

type Props = {};
const CatalogGrade = (props: Props) => {
  return (
    <CatalogGradeProvider>
      <Routes>
        <Route index element={<CatalogGradePage />}></Route>
        <Route path=":gradeId" element={<CatalogGradePage />}></Route>
        <Route path="upload" element={<UploadGradesPage />}></Route>
      </Routes>
    </CatalogGradeProvider>
  );
};
export default CatalogGrade;
